<template>
  <div class="w-full h-64 md:h-full md:min-h-64 rounded overflow-hidden">
    <template v-if="mapsPermitted == 1">
      <GmapMap
        class="rounded-xl w-full h-full relative"
        :center="{ lat: lat, lng: lng }"
        :zoom="13"
        :options="{
          zoomControl: true,
          scrollwheel: false,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false
        }"
        map-type-id="terrain">
        <gmap-custom-marker :marker="{ lat: lat, lng: lng }">
          <div class="w-4 h-4 bg-brand-blue rounded-full map-maker"></div>
        </gmap-custom-marker>
      </GmapMap>
    </template>
    <template v-else>
      <div class="w-full h-full bg-light-gray flex justify-center items-center">
        <button class="link cursor-pointer p-4" @click.prevent="enableGoogleMaps">{{ labels.googleMapsPermission }}</button>
      </div>
    </template>
  </div>
</template>

<script>
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import eventBus from '@/util/event-bus'
import { EVENT } from '@/util/enums'
import PermissionsHelper from '@/util/permissions'

export default {
  components: {
    'gmap-custom-marker': GmapCustomMarker,
  },
  props: {
    lat: {
      type: Number,
      required: true
    },
    lng: {
      type: Number,
      required: true
    },
    labels: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      mapsPermitted: 0
    }
  },
  mounted() {
    this.updatePermission()
    eventBus.$on(EVENT.PERMISSIONS_CHANGED, this.updatePermission)
  },
  methods: {
    updatePermission() {
      this.mapsPermitted = PermissionsHelper.mapsPermitted
    },
    enableGoogleMaps() {
      this.mapsPermitted = 1
      PermissionsHelper.mapsPermitted = this.mapsPermitted
      eventBus.$emit(EVENT.PERMISSIONS_CHANGED)
    }
  }
}
</script>
